// Função para sanitizar texto (remove acentos e caracteres especiais)
function sanitizarTexto(texto: string): string {
  return texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove acentos
    .replace(/[^a-zA-Z0-9\s]/g, "") // Remove caracteres especiais
    .trim()
    .toUpperCase()
}

// Função para gerar payload PIX (EMV)
export function gerarPixPayload(
  chavePix: string,
  nome: string,
  cidade: string,
  valor: string,
  identificador: string
): string {
  // Sanitiza os campos de texto
  const nomeLimpo = sanitizarTexto(nome).substring(0, 25)
  const cidadeLimpa = sanitizarTexto(cidade).substring(0, 15)
  const chaveLimpa = chavePix.trim().replace(/\s+/g, "")
  
  // Remove formatação do valor e converte para centavos
  const valorLimpo = valor.replace(/[^0-9,]/g, "").replace(",", ".")
  const valorFormatado = parseFloat(valorLimpo || "0").toFixed(2)

  // ID do Payload Format Indicator
  const payloadFormatIndicator = "000201"
  
  // Merchant Account Information
  const merchantAccountInfo = montarMerchantAccountInfo(chaveLimpa)
  
  // Merchant Category Code (0000 = não especificado)
  const merchantCategoryCode = "52040000"
  
  // Transaction Currency (986 = BRL)
  const transactionCurrency = "5303986"
  
  // Transaction Amount
  const transactionAmount = `54${valorFormatado.length.toString().padStart(2, "0")}${valorFormatado}`
  
  // Country Code (BR)
  const countryCode = "5802BR"
  
  // Merchant Name
  const merchantName = `59${nomeLimpo.length.toString().padStart(2, "0")}${nomeLimpo}`
  
  // Merchant City
  const merchantCity = `60${cidadeLimpa.length.toString().padStart(2, "0")}${cidadeLimpa}`
  
  // Additional Data Field Template (identificador da transação)
  const additionalDataField = montarAdditionalDataField(identificador)
  
  // CRC16
  const payload = 
    payloadFormatIndicator +
    merchantAccountInfo +
    merchantCategoryCode +
    transactionCurrency +
    transactionAmount +
    countryCode +
    merchantName +
    merchantCity +
    additionalDataField +
    "6304"
  
  const crc16 = calcularCRC16(payload)
  
  return payload + crc16
}

function montarMerchantAccountInfo(chavePix: string): string {
  const guiId = "0014br.gov.bcb.pix"
  const key = `01${chavePix.length.toString().padStart(2, "0")}${chavePix}`
  const merchantAccountContent = guiId + key
  
  return `26${merchantAccountContent.length.toString().padStart(2, "0")}${merchantAccountContent}`
}

function montarAdditionalDataField(identificador: string): string {
  const txId = `05${identificador.length.toString().padStart(2, "0")}${identificador}`
  return `62${txId.length.toString().padStart(2, "0")}${txId}`
}

function calcularCRC16(payload: string): string {
  let crc = 0xFFFF
  const polynomial = 0x1021
  
  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8
    
    for (let j = 0; j < 8; j++) {
      if ((crc & 0x8000) !== 0) {
        crc = (crc << 1) ^ polynomial
      } else {
        crc = crc << 1
      }
    }
  }
  
  crc = crc & 0xFFFF
  
  return crc.toString(16).toUpperCase().padStart(4, "0")
}
